import React, { useEffect, useState } from "react";

type Props = {
    /** testo da mostrare (default: italiano) */
    message?: string;
    /** link opzionale quando l'utente clicca sul banner */
    linkHref?: string;
    /** mostra anche se hostname non corrisponde (utile per sviluppo locale) */
    forceShow?: boolean;
    /** key per persistere la chiusura nel localStorage */
    persistKey?: string;
    /** se true mostra il bottone di chiusura */
    dismissible?: boolean;
};

/**
 * DevBanner
 * - Componente React + TypeScript
 * - Usa Tailwind per lo styling
 * - Mostra automaticamente il banner solo se l'hostname è `dev.sito.com`,
 *   a meno che `forceShow` sia true.
 * - Scrolling del testo (rispetta prefers-reduced-motion)
 * - Persistenza della chiusura via localStorage
 */
export default function DevBanner({
                                                  message = "ATTENZIONE: questo è un ambiente di TEST. Il sito ufficiale è presente al percorso: qrflow.it",
                                                  linkHref,
                                              }: Props) {

    return (
        <div
            role="region"
            aria-label="Banner ambiente di test"
            className="relative top-0 left-0 right-0 z-50 flex items-center"
            style={{
                // garantiamo che non copra elementi importanti (usa padding-top nel root se necessario)
            }}
        >
            <div className="w-full">
                <div className="mx-auto max-w-full bg-yellow-400 text-black shadow-md">
                    <div className="relative flex items-center px-3 py-2">
                        {/* Marquee container */}
                        <a
                            href={linkHref ?? "#"}
                            onClick={(e) => {
                                if (!linkHref) e.preventDefault();
                            }}
                            className="flex-1 overflow-hidden whitespace-nowrap"
                            aria-live="polite"
                        >
                            <div
                                className="inline-block py-1"
                                style={{
                                    // la riga qui sotto definisce un'animazione CSS per far scorrere il testo
                                    // l'animazione è definita nel <style> più sotto
                                }}
                            >
                                <div className="marquee" style={{ display: "inline-block" }}>
                                    {/* duplico il testo due volte per loop continuo */}
                                    <span className="mr-8">{message}</span>
                                    <span className="mr-8">{message}</span>
                                </div>
                            </div>
                        </a>

                    </div>
                </div>
            </div>

            {/* styles specifici al componente - rispetta prefers-reduced-motion */}
            <style>{`
        /* keyframes per far scorrere il contenuto verso sinistra */
        @keyframes marquee-anim {
          0% { transform: translateX(0%); }
          100% { transform: translateX(-50%); }
        }

        .marquee {
          display: inline-block;
          will-change: transform;
          animation: marquee-anim 15s linear infinite;
        }

        /* Rispetta utenti che richiedono riduzione del movimento */
        @media (prefers-reduced-motion: reduce) {
          .marquee {
            animation: none;
          }
        }

        /* Piccola aggiunta: sposta il body verso il basso se il tuo layout usa "fixed top-0" */
        /* Inserisci in questo file o globalmente: body { padding-top: 44px; } */
      `}</style>
        </div>
    );
}
